/**
 * @typedef {import('./NavigationListProps').LinkList} Props
 * @typedef {Readonly<{
 * 	children?: React.ReactNode,
 * 	disable?: boolean,
 *  exact?: boolean,
 *  icon: string,
 *  isSubmenu?: boolean,
 * 	onListItemClick?: (
 * 		event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
 * 	) => void,
 * 	to: string
 * }>} PublicProps
 */

import { NavLink } from 'react-router-dom';
import { withAuth } from '../../shared/AuthProvider';
import { withSettings } from '../../shared/SettingProvider/SettingProvider';
import ExternalAnchor from '../../shared/ExternalAnchor';
import NavigationListItemContent from './NavigationListItemContent';
import React from 'react';

/** @extends {React.Component<Props>} */
class NavigationListLink extends React.Component {
	/**
	 * @param {React.ReactElement} content
	 * @returns {React.ReactElement}
	 */
	#generateLink(content) {
		if (this.props.to.includes('://')) {
			return (
				<ExternalAnchor
					className="nav-link"
					href={this.props.to}
					onClick={this.props.onListItemClick}
					renderSpan={false}
				>
					{content}
				</ExternalAnchor>
			);
		}
		const isDisable =
			this.props?.auth?.isContactLimitExceeded &&
			this.props.disable &&
			this.props.settings.features.get(
				'agent:limit_contacts_on_free_accounts'
			);

		if (isDisable) {
			return (
				<section className="nav-link opacity-50 ">{content}</section>
			);
		}
		return (
			<NavLink
				className="nav-link"
				exact={this.props.exact}
				onClick={this.props.onListItemClick}
				style={
					this.props.isSubmenu
						? {
								fontSize: '1.125rem',
								lineHeight: '1.25',
								marginBottom: '1.25rem',
								marginLeft: '0.75rem',
						  }
						: undefined
				}
				to={this.props.to}
			>
				{content}
			</NavLink>
		);
	}

	/**
	 * @returns {React.ReactElement}
	 */
	render() {
		/** @type {React.ReactElement} */
		const linkContent = (
			<NavigationListItemContent
				icon={this.props.icon}
				isSubmenu={this.props.isSubmenu}
			>
				{this.props.children}
			</NavigationListItemContent>
		);

		return (
			<li
				className={
					this.props.isSubmenu
						? 'nav-item nav-submenu-item'
						: 'nav-item'
				}
			>
				{this.#generateLink(linkContent)}
			</li>
		);
	}
}

export default /** @type {React.ComponentType<PublicProps>} */ (
	/** @type {(component: React.ComponentType<Props>) => React.ComponentType<PublicProps>} */ (
		/** @type {unknown} */ (withAuth)
	)(
		/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Props>} */ (
			/** @type {unknown} */ (withSettings)
		)(NavigationListLink)
	)
);
